<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Aditivos do Convênio
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-tabela
                        idTabela="tbAditivos"
                        :itens="aditivos"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false"
                    >
                    <template slot="dataAditivo" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.dataAditivo ? $moment(data.dataAditivo).format('DD/MM/YYYY') : '' }}
                        </p>
                    </template>
                    <template slot="aditivo" slot-scope="data">
                        <p class="text-left m-0" v-if="data.tipoAditivo == 1">
                            {{ $moment(data.dataProrrogada).format('DD/MM/YYYY') }}
                        </p>
                        <p class="text-left m-0" v-if="data.tipoAditivo == 2">
                            {{ data.valorAditivo | currency }}
                        </p>
                    </template>
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-aditivo
                                :convenio="convenio"
                                class="mr-2"
                                v-if="$temAcessoView('CONV-ADT-01')"
                                @atualizarLista="atualizarLista()"
                            >
                            </btn-inserir-aditivo>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-atualizar-aditivo
                                v-if="$temAcessoView('CONV-ADT-01')"
                                :convenio="convenio"
                                :aditivo="data"
                                @atualizarLista="atualizarLista()">
                            </btn-atualizar-aditivo>
                            <btn-excluir-aditivo
                                class="text-danger float-left mr-1"
                                v-if="$temAcessoView('CONV-ADT-02')"
                                :convenio="convenio"
                                :aditivo="data"
                                @atualizarLista="atualizarLista()"
                            ></btn-excluir-aditivo>
                        <span class="text-primary float-left mr-1">
                            <i
                                class="fa fa-unlock-alt fa-lg icon-button"
                                title="Ativar Aditivo"
                                @click.stop="confirmaAtivar(data.idAditivo)"
                                v-if="data.statusAditivo == 1"
                            ></i>
                        </span>
                    </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import BtnInserirAditivo from '../cadastro/aditivos/BtnInserirAditivo.vue'
    import BtnAtualizarAditivo from '../cadastro/aditivos/BtnAtualizarAditivo.vue'
    import BtnExcluirAditivo from '../cadastro/aditivos/BtnExcluirAditivo.vue'
    import ConveniosServicos from '../ConveniosServicos'

    export default {
        components: {
            BtnAtualizarAditivo,
            BtnExcluirAditivo,
            BtnInserirAditivo,
        },

        props: {
            convenio: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                erros: [],
                itensPorPagina: 5,
                aditivos: [],
                campos: [
                    {
                        key: 'objeto',
                        label: 'Objeto',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'tipoAditivoDesc',
                        label: 'Tipo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'aditivo',
                        label: 'Aditivo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'statusAditivoDesc',
                        label: 'Status',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acoes',
                        label: ''
                    }
                ],

            }
        },

        methods:{
            atualizarLista(){
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterPorId(this.convenio.idConvenio)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.aditivos = response.data.aditivos
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            confirmaAtivar(id){
                this.$swal({
                    title: 'Ativar Aditivo',
                    html: 'Deseja Ativar o Aditivo ?',
                    icon: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.ativar(id)
                    }
                })
            },

            ativar(id){
                this.$store.dispatch('addRequest')
                ConveniosServicos.ativarAditivos(id)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.atualizarLista()
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },
        },

        watch:{
            convenio(){
                if(this.convenio){
                    this.aditivos = this.convenio.aditivos
                }
            }
        },


    }
</script>
